module.exports = "/_next/static/images/photoEdwardJares-39c8a782d0f801d8e8e109a5420128aa.webp";